module.exports = "/build/web/svg/sponsor/heineken-wit.ef9426f3e469ffebc9904cc066dc90a4.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/heineken-wit.svg
// module id = 212
// module chunks = 24